import { Routes, Route, Navigate } from 'react-router-dom';
// import EmployeeDashboard from '../../module/employee/pages/EmployeeDashboard'; // Example
// import MyJobs from '../../module/employee/pages/MyJobs'; // Example
import PrivateRoute from './privateRoute';
import UserResolver from '../reolvers/userResolver';

const EmployeeRoutes = () => {
    return (
        <UserResolver>
            <Routes>
                {/* <Route path="/employee/dashboard" element={<PrivateRoute><EmployeeDashboard /></PrivateRoute>} />
                <Route path="/employee/my-jobs" element={<PrivateRoute><MyJobs /></PrivateRoute>} /> */}
                <Route path="*" element={<Navigate to="/employee/dashboard" replace />} />
            </Routes>
        </UserResolver>
    );
};

export default EmployeeRoutes;